import { DownloadFile, enqueueSnackbar, UploadFile } from 'actions';
import {
	GetRepositoryFilesRequest,
	SaveExcelFileRequest,
	DownloadRepositoryFileRequest,
	RemoveRepositoryFileRequest
} from '../requests/RepositoryExcelRequests';

export const SET_FORM_STATE = 'SET_FORM_STATE';
export const GET_REPOSITORY_FILES = 'GET_REPOSITORY_FILES';
export const TOGGLE_REMOVE_REPOSITORY_FILE_DIALOG = 'TOGGLE_REMOVE_REPOSITORY_FILE_DIALOG';

const onSetFormState = (value) => ({
	type: SET_FORM_STATE,
	formState: value
});

const onGetRepositoryFiles = (value) => ({
	type: GET_REPOSITORY_FILES,
	filesInfo: value
});

const onToggleRemoveRepositoryFileDialog = (visible, tableId, filename) => ({
	type: TOGGLE_REMOVE_REPOSITORY_FILE_DIALOG,
	visible,
	tableId,
	filename
});

export const SetFormState = (value) => (dispatch) => {
	dispatch(onSetFormState(value));
};

export const GetRepositoryFiles = (userId) => async (dispatch) => {
	await GetRepositoryFilesRequest(userId).then(response => {
		dispatch(onGetRepositoryFiles(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const SaveExcelFile = (userId, filePath) => async (dispatch) => {
	await SaveExcelFileRequest(userId, filePath).then(response => {
		dispatch(GetRepositoryFiles());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadExcelFile = (userId, file) => async (dispatch) => {
	await UploadFile(file).then(response => {
		dispatch(SaveExcelFile(userId, response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const DownloadRepositoryFile = (userId, tableId, filename) => async (dispatch) => {
	await DownloadRepositoryFileRequest(userId, tableId, filename).then(response => {
		dispatch(DownloadFile(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ToggleRemoveRepositoryFileDialog = (visible, tableId, filename) => (dispatch) => {
	dispatch(onToggleRemoveRepositoryFileDialog(visible, tableId, filename));
};

export const RemoveRepositoryFile = (userId, tableId, filename) => async (dispatch) => {
	await RemoveRepositoryFileRequest(userId, tableId, filename).then(response => {
		dispatch(GetRepositoryFiles());
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
